export enum ConfirmationButtonType {
  Confirm,
  Cancel,
  SecondaryConfirm
}
